import throttle from "lodash/throttle";

class BackToTop {
  constructor() {
    this.backToTop = document.getElementById("back-to-top");
    this.header = document.getElementById("header");
    this.events();
  }

  events() {
    window.addEventListener(
      "scroll",
      throttle(() => {
        this.scrolled = window.pageYOffset;
        this.addRemoveScrolled();
      }, 200)
    );
  }

  addRemoveScrolled() {
    if (this.scrolled > 100) {
      this.backToTop.classList.add("scrolled");
      this.header.classList.add("scrolled");
    } else {
      this.backToTop.classList.remove("scrolled");
      this.header.classList.remove("scrolled");
    }
  }
}

export default BackToTop;
